/** Marks a channel-logo `<img>`, so the lineup's error listener touches nothing else. */
export const CHANNEL_LOGO_IMAGE_ATTRIBUTE = "data-cl-logo";

/**
 * Set once the fallback is in, so a fallback that also fails cannot loop. `channel-logo.module.css`
 * reads it by name too (a self-badged tile takes its disc back), so rename both together.
 */
export const CHANNEL_LOGO_FALLBACK_ATTRIBUTE = "data-cl-logo-fallback";

/* Prod parity: OV can send a logo URL that serves nothing, and v2's `handleChannelLogoError` swaps in
   this image. Same URL as `NO_LOGO_ASSET` (lib/helper/channel-logo-url.ts); DDS cannot import lib, so
   change both together. v3 swaps the src, and its stylesheet gives a self-badged tile its disc back;
   v2 also restyles the chip. */
export const CHANNEL_LOGO_FALLBACK_URL =
  "https://www.directv.com/assets/content/youlnv3nxj/web/channel-logo_missing-logo.png";

/** Swaps a failed channel logo for the fallback, once. Returns whether it swapped. */
export function applyChannelLogoFallback(target: EventTarget | null): boolean {
  if (
    typeof HTMLImageElement === "undefined" ||
    !(target instanceof HTMLImageElement) ||
    !target.hasAttribute(CHANNEL_LOGO_IMAGE_ATTRIBUTE) ||
    target.hasAttribute(CHANNEL_LOGO_FALLBACK_ATTRIBUTE)
  ) {
    return false;
  }
  target.setAttribute(CHANNEL_LOGO_FALLBACK_ATTRIBUTE, "");
  target.src = CHANNEL_LOGO_FALLBACK_URL;
  return true;
}

/** An image whose load already failed: finished, nothing decoded, and it had a source to fail on. */
export function hasFailedToLoad(image: HTMLImageElement): boolean {
  return image.complete && image.naturalWidth === 0 && (image.getAttribute("src") ?? "") !== "";
}
